import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConstants } from 'src/app/app.constants';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  dailyReports(data): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.REPORTS.DAILY_REPORT}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  weeklyReports(data): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.REPORTS.WEEKLY_REPORT}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  quiriesReports(data): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.REPORTS.QUIRIES_REPORT}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  downloadDailyReports(data): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.REPORTS.DOWNLOAD_DAILY_REPORT}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  downloadMonthlyReports(data): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.REPORTS.DOWNLOAD_MONTHLY_REPORT}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  downloadQuiries(data): Observable<any> {
    return this.http.post(`${AppConstants.API_ENDPOINT1}${AppConstants.API.REPORTS.QUIRIES_DOWNLOAD}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
